import React from 'react';
import styled from 'styled-components';

import { KeyValuePair } from 'models';

const Card = styled.div<{ selected: boolean }>`
    display: flex-wrap;
    margin: 10px;
    padding: 13px 50px 13px 50px;
    width: 150px;
    border-width: 1px;
    color: black;
    background-color: white;
    border-color: lightgrey;
    border-style: solid;
    transition: background-color 0.2s ease, color 0.2s ease;
    display: inline-block;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    align-self: center;
    text-align: center;

    background-color: ${(props) => props.selected ? '#FF7203' : 'white'};
    color: ${(props) => props.selected ? 'white' : 'black'};
    outline: ${(props) => props.selected ? 'none' : ''};

    :hover {
        cursor: pointer;
        background-color: #FF7203;
        color: white;
    }

    :focus {
        background-color: #FF7203;
        color: white;
        outline: none;
    }
`;

interface IProps {
  obj: KeyValuePair;
  onClick: (key: string, value: string) => void;
  selected: boolean;
}

const CardRadioButton: React.FC<IProps> = ({ obj, onClick, selected }) => {
  return (
    <Card
      selected={selected}
      tabIndex={0}
      onClick={() => onClick(obj.key, obj.value)}
    >
      {obj.value} {obj.unit}
    </Card>
  );
};

export default CardRadioButton;
